import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import FoundationTestimonial from './components/FoundationTestimonial';
import Mission from './components/Mission';
import WhatWeDo from './components/WhatWeDo';
import Eligibility from './components/Eligibility';
import Process from './components/Process';
import Impact from './components/Impact';
import Contact from './components/Contact';
import Footer from './components/Footer';

import './App.css';

function App() {
  return (
    <>
      <Header />
      <Hero />
      <FoundationTestimonial />
      <Mission />
      <WhatWeDo />
      <Eligibility />
      <Process />
      <Impact />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
